import React, { useCallback, useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import debounce from 'lodash/debounce'
import { getNumberOfDays, getToday, datesAreSame, convertYear, constructDate, isValidDate, dateHelper } from './helpers'
import { Button } from '../../../index'
import { type } from 'os'
import { start } from 'repl'
import { init } from '@sentry/react'

const useDate = ({ value, depth, onChange, isRange = false, min, max }) => {
    // const [startDay, setStartDay] = useState<number>(depth === 'day' ? null : 1)
    // const [startMonth, setStartMonth] = useState<number>(depth !== 'year' ? null : 0)
    // const [startYear, setStartYear] = useState<number>()
    const [endDay, setEndDay] = useState<number>(depth === 'day' ? null : 1)
    const [endMonth, setEndMonth] = useState<number>(depth !== 'year' ? null : 0)
    const [endYear, setEndYear] = useState<number>()
    const [startDate, setStartDate] = useState<Date>(null)
    const [endDate, setEndDate] = useState<Date>(null)
    const [isStartValid, setIsStartValid] = useState<boolean>()
    const [isEndValid, setIsEndValid] = useState<boolean>()
    const [isDirty, setIsDirty] = useState<boolean>(false)
    const [internalValue, setInternalValue] = useState(null)

    const initialDay = depth === 'day' ? null : 1
    const initialMonth = depth !== 'year' ? null : 0
    const [startDateEls, setStartDateEls] = useState<[number, number, number]>([initialDay, initialMonth, null])
    const [endDateEls, setEndDateEls] = useState<[number, number, number]>([initialDay, initialMonth, null])
    const handleSetStartDateEl = (idx) => (val) => {
        setStartDateEls((prev) => {
            prev[idx] = val
            return [...prev]
        })
    }
    const handleSetEndDateEl = (idx) => (val) => {
        setEndDateEls((prev) => {
            prev[idx] = val
            return [...prev]
        })
    }

    const handleConstructDate = () => {
        const constructedStart = constructDate(...startDateEls)
        const _isStartValid = isValidDate(constructedStart)
        if (_isStartValid) {
            if (min && constructedStart < min) {
                // setStartDate(min)
                const d = moment(min)
                setStartDateEls([d.get('D'), d.get('M'), d.get('y')])
                return
            } else if (max && constructedStart > max) {
                // setEndDate(max)
                // updateDisplay(true, max)
                return
            } else {
                setStartDate(constructedStart)
            }
        } else {
            setStartDate(null)
        }
        setIsStartValid(_isStartValid)

        if (isRange) {
            let constructedEnd = constructDate(...endDateEls)
            const _isEndValid = isValidDate(constructedEnd)
            if (_isEndValid) {
                setEndDate(constructedEnd)
            } else {
                setEndDate(null)
            }
            setIsEndValid(_isEndValid)
        }
    }
    //
    // const updateDisplay = (isStart, date) => {
    //     const d = moment(date)
    //     if (isStart) {
    //         setStartDateEls([d.get('D'), d.get('M'), d.get('y')])
    //     } else {
    //         setEndDateEls([d.get('D'), d.get('M'), d.get('y')])
    //     }
    // }
    const parseElements = (val) => {
        const start = isRange ? val?.start ?? null : val
        if (start) {
            const s = moment(start)
            if (s.isValid()) {
                setStartDateEls([s.get('D'), s.get('M'), s.get('y')])
            }
        }
        if (isRange) {
            const end = val?.end ?? null
            if (end) {
                const e = moment(end)
                if (e.isValid()) {
                    setEndDateEls([e.get('D'), e.get('M'), e.get('y')])
                }
            }
        }
    }

    //Construct date when date elements change
    useEffect(() => {
        const s = startDateEls
        handleConstructDate()
    }, [startDateEls, endDateEls])

    //Call onChange when date changes
    useEffect(() => {
        let val: any = startDate
        if (isRange) {
            if (endDate && startDate > endDate) {
                setEndDate(startDate)
                const s = moment(startDate)
                setEndDateEls([s.get('D'), s.get('M'), s.get('y')])
                return
            }

            val = {
                start: startDate || null,
                end: endDate || null,
            }
        }
        onChange(val)
        setIsDirty(true)
    }, [startDate, endDate])

    useEffect(() => {
        if (JSON.stringify(value) !== JSON.stringify(internalValue)) {
            setInternalValue(value)
        }
    }, [value])

    useEffect(() => {
        if (JSON.stringify(value) !== JSON.stringify(internalValue)) {
            parseElements(value)
        }
    }, [value])
    return {
        startDate,
        endDate,
        startDay: startDateEls[0],
        setStartDay: handleSetStartDateEl(0),
        startMonth: startDateEls[1],
        setStartMonth: handleSetStartDateEl(1),
        startYear: startDateEls[2],
        setStartYear: handleSetStartDateEl(2),
        endDay: endDateEls[0],
        setEndDay: handleSetEndDateEl(0),
        endMonth: endDateEls[1],
        setEndMonth: handleSetEndDateEl(1),
        endYear: endDateEls[2],
        setEndYear: handleSetEndDateEl(2),
        isStartValid,
        isEndValid,
        isDirty,
    }
}

export default useDate
